import { ONBOARDING_WELCOME_LIST } from './typesOfOnboarding/welcomeOnboarding/constants'
import { EOnboardingType } from './Onboarding.types'

export const ONBOARDINGS_MAP = {
  [EOnboardingType.MAIN_PAGE_WELCOME]: ONBOARDING_WELCOME_LIST
}

export const SCROLL_OFFSET = 200
